/*
 * File: modal.ts
 * File Created: 2024-01-08 03:38:49
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-24 06:56:34
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { createCustomPrevent } from "@root/core/event-modifier/create-custom-prevent";
import { PropInnateSync } from "@root/core/vue-props";
import { Component } from "vue-property-decorator";

@Component
export default class Modal extends BaseComponent {
    @PropInnateSync("visible", { type: Boolean, default: false })
    innateVisible!: boolean;

    /// made it easy with label / value
    @PropInnateSync("value", { type: String, required: false })
    innateValue!: string;

    /// public methods
    show() {
        this.innateVisible = true;
    }
    hide() {
        this.innateVisible = false;
    }
    toggle() {
        this.innateVisible = !this.innateVisible;
    }

    /// handle events - cancel
    doCancel(e) {
        const customEvent = createCustomPrevent();
        this.$emit("cancel", customEvent);

        const defaultHandleExists = e && e.preventDefault;
        if (customEvent.defaultPrevented) {
            if (defaultHandleExists) e.preventDefault();
        } else {
            this.hide();
        }
    }

    /// slots definition
    publicSlots = {
        title: "@title",
        footer: "@footer",
    };
}
